import {
  vs2ngaVersionListConstants,
  vs2ngaVersionUploadConstants,
  vs2ngaVersionDeleteConstants,
  vs2ngaVersionConstants,
} from "../_redux-constants";

export function vs2ngaVersionListReducer(
  state = {
    vs2ngaVersionListLoading: false,
    vs2ngaVersionListData: null,
    vs2ngaVersionListError: null,

    vs2ngaVersionUploadLoading: false,
    vs2ngaVersionUploadData: null,
    vs2ngaVersionUploadError: null,

    vs2ngaVersionLoading: false,
    vs2ngaVersionData: null,
    vs2ngaVersionError: null,
  },
  action
) {
  switch (action.type) {
    case vs2ngaVersionListConstants.VS2NGAVERSION_LIST_LOADING:
      return Object.assign({}, state, {
        vs2ngaVersionListLoading: true,
        vs2ngaVersionListData: null,
        vs2ngaVersionListError: null,
      });
    case vs2ngaVersionListConstants.VS2NGAVERSION_LIST_SUCCESS:
      return Object.assign({}, state, {
        vs2ngaVersionListLoading: false,
        vs2ngaVersionListData: action.data,
      });
    case vs2ngaVersionListConstants.VS2NGAVERSION_LIST_FAILURE:
      return Object.assign({}, state, {
        vs2ngaVersionListLoading: false,
        vs2ngaVersionListData: null,
        vs2ngaVersionListError: action.error,
      });
    case vs2ngaVersionUploadConstants.VS2NGAVERSION_UPLOAD_LOADING:
      return Object.assign({}, state, {
        vs2ngaVersionUploadLoading: true,
        vs2ngaVersionUploadData: null,
        vs2ngaVersionUploadError: null,
      });
    case vs2ngaVersionUploadConstants.VS2NGAVERSION_UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        vs2ngaVersionUploadLoading: false,
        vs2ngaVersionUploadData: action.data,
      });
    case vs2ngaVersionUploadConstants.VS2NGAVERSION_UPLOAD_FAILURE:
      return Object.assign({}, state, {
        vs2ngaVersionUploadLoading: false,
        vs2ngaVersionUploadData: null,
        vs2ngaVersionUploadError: action.error,
      });
    case vs2ngaVersionConstants.VS2NGAVERSION_LOADING:
      return Object.assign({}, state, {
        vs2ngaVersionLoading: true,
        vs2ngaVersionData: null,
        vs2ngaVersionError: null,
      });
    case vs2ngaVersionConstants.VS2NGAVERSION_SUCCESS:
      return Object.assign({}, state, {
        vs2ngaVersionLoading: false,
        vs2ngaVersionData: action.data,
      });
    case vs2ngaVersionConstants.VS2NGAVERSION_FAILURE:
      return Object.assign({}, state, {
        vs2ngaVersionLoading: false,
        vs2ngaVersionData: null,
        vs2ngaVersionError: action.error,
      });
    case vs2ngaVersionDeleteConstants.VS2NGAVERSION_DELETE_LOADING:
      return Object.assign({}, state, {
        vs2ngaVersionDeleteLoading: true,
        vs2ngaVersionDeleteData: null,
        vs2ngaVersionDeleteError: null,
      });
    case vs2ngaVersionDeleteConstants.VS2NGAVERSION_DELETE_SUCCESS:
      return Object.assign({}, state, {
        vs2ngaVersionDeleteLoading: false,
        vs2ngaVersionDeleteData: action.data,
      });
    case vs2ngaVersionDeleteConstants.VS2NGAVERSION_DELETE_FAILURE:
      return Object.assign({}, state, {
        vs2ngaVersionDeleteLoading: false,
        vs2ngaVersionDeleteData: null,
        vs2ngaVersionDeleteError: action.error,
      });
    default:
      return state;
  }
}
